import { create } from 'zustand';
import { IExercise } from '../../../core/models/exercise';

export interface IExercisesFilterList {
  favorite?: boolean;
  unanswered?: boolean;
  wrongAnswer?: boolean;
  rightAnswer?: boolean;
  difficulty?: string[];
  selectedYear?: string[];
  institutionType?: string[];
  trial?: string;
  questions?: string[];
  selectedSubjects?: string[];
  isEnem?: string[];
  page: number;
  module?: string;
}

interface ExercisePageState {
  exercises: IExercise[];
  fullExerciseList: IExercise[];
  exercisesFilterList: IExercisesFilterList | null;
  fullExerciseFilterList: IExercisesFilterList | null;
  actualExercise: IExercise | null;
  nextExercise: IExercise | null;
  previousExercise: IExercise | null;
  setExercises: (exercises: IExercise[]) => void;
  setFullExerciseList: (exercises: IExercise[]) => void;
  setExercisesFilterList: (filters: IExercisesFilterList) => void;
  setFullExerciseFilterList: (filters: IExercisesFilterList) => void;
  setActualExercise: (exercise: IExercise | null) => void;
  setNextExercise: (exercise: IExercise | null) => void;
  setPreviousExercise: (exercise: IExercise | null) => void;
  invalidateExerciseListCache: () => void;
  resetAll: () => void;
}

export const useExercisePageStore = create<ExercisePageState>((set) => ({
  exercises: [],
  fullExerciseList: [],
  exercisesFilterList: null,
  fullExerciseFilterList: null,
  actualExercise: null,
  nextExercise: null,
  previousExercise: null,
  setExercises: (exercises) => set({ exercises }),
  setFullExerciseList: (fullExerciseList) => set({ fullExerciseList }),
  setExercisesFilterList: (exercisesFilterList) => set({ exercisesFilterList }),
  setFullExerciseFilterList: (fullExerciseFilterList) => set({ fullExerciseFilterList }),
  setActualExercise: (actualExercise) => set({ actualExercise }),
  setNextExercise: (nextExercise) => set({ nextExercise }),
  setPreviousExercise: (previousExercise) => set({ previousExercise }),
  invalidateExerciseListCache: () => set({
    exercisesFilterList: null,
    fullExerciseFilterList: null,
  }),
  resetAll: () => set({
    exercises: [],
    fullExerciseList: [],
    exercisesFilterList: null,
    fullExerciseFilterList: null,
    actualExercise: null,
    nextExercise: null,
    previousExercise: null,
  }),
}));
